/**
 * @fileoverview A function that provides the invites API.
 *
 * @example
 * const { result } = renderHook(() => useInvitesAPI())
 */

import { assignmentsApi } from './assignments'

export const invitesApi = assignmentsApi.injectEndpoints({
    endpoints: (builder) => ({
        getInvites: builder.query<Novoic.API.AssignmentInvitation[], void>({
            query: () => {
                return {
                    url: 'assignmentsInvitations',
                    method: 'GET',
                }
            },
        }),

        getInviteById: builder.query<Novoic.API.AssignmentInvitation, string>({
            query: (id: string) => {
                return {
                    url: `assignmentsInvitations/${id}`,
                    method: 'GET',
                }
            },
        }),

        getInvitesForStudyId: builder.query<Novoic.API.AssignmentInvitation[], string>({
            query: (studyId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('studies', studyId)
                return {
                    url: `assignmentsInvitations?with_patient=false&${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        getInvitesCountForStudyId: builder.query<{ count: number }, string>({
            query: (studyId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('studies', studyId)
                return {
                    url: `assignmentsInvitations/count?with_patient=false&${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        createAssignmentInvite: builder.mutation<
            Novoic.API.AssignmentInvitation,
            Partial<Novoic.API.AssignmentInvitation>
        >({
            query: (assignmentInvite) => {
                return {
                    url: 'assignmentsInvitations',
                    method: 'POST',
                    data: assignmentInvite,
                }
            },
            invalidatesTags: ['Assignment', 'AssignmentCounter'],
        }),
    }),
})

export const {
    useGetInvitesCountForStudyIdQuery,
    useGetInviteByIdQuery,
    useGetInvitesForStudyIdQuery,
    useGetInvitesQuery,
    useCreateAssignmentInviteMutation,
} = invitesApi
